module.exports = __webpack_public_path__ + "static/ff-saleslanding-icon-climatechange.298da1b0.png";